import { createModal } from "./coreModal.js";

export function openImageModal({ src }) {
  const modal = createModal({ modifier: "l-modal--image" });
  if (!modal) return;

  const img = document.createElement("img");
  img.src = src;
  img.alt = "";

  modal.body.appendChild(img);
}
